"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationWithTeliaContent = void 0;
const react_1 = __importDefault(require("react"));
const RootStore_1 = require("../../../stores/RootStore");
const CommunicationWithTeliaContent = () => {
    const { translate } = react_1.default.useContext(RootStore_1.RootStoreContext).translateStore;
    return react_1.default.createElement("p", null, translate('gdpr.privacy.notification.communication.with.telia.content.text'));
};
exports.CommunicationWithTeliaContent = CommunicationWithTeliaContent;
